/**
 * Routing debug telemetry — opt-in via `localStorage.flock_debug_routing = '1'`.
 *
 * Used by AuthContext, OnboardingGuard, TermsConsentPage, ConnectAppsPage,
 * BillingRequiredPage to emit timestamped console.debug traces. Lets developers
 * diagnose "flash" reports from users by copying the console output.
 *
 * Doctrine: PRP `flash-diagnostics-onboarding-flow` (2026-05-26, D7).
 */
export const isDebugRouting = () =>
  typeof window !== 'undefined' &&
  typeof localStorage !== 'undefined' &&
  localStorage.getItem('flock_debug_routing') === '1';

/**
 * Emit a routing trace line. No-op unless the debug flag is active.
 * @param {string} source - Component or module emitting (e.g. 'OnboardingGuard').
 * @param {string} event - Short event name (e.g. 'Navigate', 'decision', 'TransitionShell').
 * @param {object} [details] - Free-form payload (paths, reasons, profile flags).
 */
export function traceRouting(source, event, details = {}) {
  if (!isDebugRouting()) return;
  // eslint-disable-next-line no-console
  console.debug(`[${source}:t=${Date.now()}] ${event}`, details);
}
